/**
 * 半角を全角へ変換する
 * @param value 半角カタカナ、半角英数字
 * @returns
 */
export const toZenkaku = (value: string | undefined) => {
  return value
    ?.replace(/[\uFF61-\uFF9F]+/g, (s) => s.normalize('NFKC'))
    .replace(/[A-Za-z0-9]/g, (char) => String.fromCharCode(char.charCodeAt(0) + 0xfee0));
};

/**
 * 口座番号を全角から半角への変換
 * @param str 全角英数字
 * @returns
 */
export const toHankaku = (str: string) => {
  const half_char_str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0));
  return half_char_str;
};

/**
 * 全角ひらがなを全角カタカナに変換
 * @param value 全角ひらがな
 * @returns
 */
export const toKatakana = (value: string | undefined) => {
  return value?.replace(/[ぁ-ゖ]/g, (char) => String.fromCharCode(char.charCodeAt(0) + 0x60));
};
/**
 * カナ小文字をカナ大文字に変換する(例：トウキョウ -> トウキヨウ)
 * @param value カタカナの文字列
 */
export const normalizeKatakana = (value: string) => {
  return value.replace(/[ァィゥェォッャュョヮヵヶ]/g, (char) => SMALL_TO_LARGE_KATAKANA[char] ?? char);
};

const SMALL_TO_LARGE_KATAKANA: Record<string, string> = {
  ァ: 'ア',
  ィ: 'イ',
  ゥ: 'ウ',
  ェ: 'エ',
  ォ: 'オ',
  ッ: 'ツ',
  ャ: 'ヤ',
  ュ: 'ユ',
  ョ: 'ヨ',
  ヮ: 'ワ',
  ヵ: 'カ',
  ヶ: 'ケ',
};
